import type { CanvasData } from '../data'

export const blankTemplate: CanvasData = {
	version: 1,
	layers: {},
	layerTree: [],
}
